import { render, staticRenderFns } from "./DocumentsModal.vue?vue&type=template&id=6f8ec1b0&scoped=true"
import script from "./DocumentsModal.vue?vue&type=script&lang=js"
export * from "./DocumentsModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentsModal.vue?vue&type=style&index=0&id=6f8ec1b0&prod&scoped=true&lang=scss"
import style1 from "./DocumentsModal.vue?vue&type=style&index=1&id=6f8ec1b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ec1b0",
  null
  
)

export default component.exports